function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Dropdown from 'svg/dropdown.svg';
import messages from '../../../messages';
import styles from '../GlucoseSettings.pcss';
var _React_PureComponent;
class GlucoseLevel extends (_React_PureComponent = React.PureComponent) {
    renderItem(id, messageKey) {
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: id,
            labelMessage: messages.labels[messageKey],
            formValues: this.props.formValues,
            children: /*#__PURE__*/ _jsx(Input, {
                placeholder: messages.placeholders[messageKey],
                onChange: (input)=>this.props.onSetValue(input),
                type: "number",
                isDisabled: !this.props.hasElevatedPermissions,
                suffix: this.props.conversion.unitSymbol
            })
        });
    }
    renderContent() {
        const { type } = this.props;
        const { isOpen } = this.state;
        if (!isOpen) {
            return null;
        }
        return /*#__PURE__*/ _jsxs(motion.div, {
            initial: {
                height: 0
            },
            animate: {
                height: 'auto'
            },
            exit: {
                height: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: this.renderItem(`range-${type}-preMeal-lowThreshold`, 'glucosePreMealLow')
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: this.renderItem(`range-${type}-preMeal-highThreshold`, 'glucosePreMealHigh')
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: this.renderItem(`range-${type}-postMeal-lowThreshold`, 'glucosePostMealLow')
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: this.renderItem(`range-${type}-postMeal-highThreshold`, 'glucosePostMealHigh')
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: this.renderItem(`range-${type}-critical-lowThreshold`, 'glucoseCriticalLow')
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: this.renderItem(`range-${type}-critical-highThreshold`, 'glucoseCriticalHigh')
                        })
                    ]
                })
            ]
        });
    }
    render() {
        const { type } = this.props;
        const { isOpen } = this.state;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.settingItem_container,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.settingItem_header,
                    onClick: ()=>this.setState({
                            isOpen: !isOpen
                        }),
                    role: "presentation",
                    children: /*#__PURE__*/ _jsxs("h2", {
                        className: cn('title', styles.title_header),
                        children: [
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers[`glucose${type}`])),
                            /*#__PURE__*/ _jsx(motion.div, {
                                initial: {
                                    rotate: '180deg'
                                },
                                animate: isOpen ? 'open' : 'close',
                                variants: {
                                    open: {
                                        rotate: '180deg'
                                    },
                                    close: {
                                        rotate: '0deg'
                                    }
                                },
                                children: /*#__PURE__*/ _jsx(Dropdown, {})
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(AnimatePresence, {
                    children: this.renderContent()
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isOpen: false
        };
    }
}
_define_property(GlucoseLevel, "propTypes", {
    // Explicit props
    formValues: PropTypes.object,
    hasElevatedPermissions: PropTypes.bool,
    type: PropTypes.string,
    conversion: PropTypes.object,
    // Explicit actions
    onSetValue: PropTypes.func
});
export default withStyles(styles)(GlucoseLevel);
